
import { Currency, USD_ATTRIBUTES } from './currency';

import { isNil } from 'lodash-es';


export interface MoneyAttributes  {
  cents?: number;
  currency?: Currency;
  fractional?: number;
  symbol?: string;
}

export class Money implements MoneyAttributes {
  cents: number;
  currency: Currency;
  fractional: number;
  symbol: string;

  constructor(attributes: MoneyAttributes | null) {
    this.currency = new Currency(USD_ATTRIBUTES);
    this.symbol = '$';
    this.fractional = 0;
    this.cents = 0;

    if (!!attributes) {
      const { cents, currency, fractional, symbol } = attributes;

      if (!!currency) {
        this.currency = new Currency(currency);
      }

      this.symbol = isNil(symbol) ? '$' : symbol;
      this.fractional = isNil(fractional) ? (cents || 0) : fractional;
      this.cents = isNil(cents) ? (fractional || 0) : cents;
    }
  }

  get currencySymbol(): string {
    return this.currency.symbol ?? '$';
  }

  get unit(): number {
    const subunitToUnit = this.currency.subunit_to_unit;
    const divisor = !isNil(subunitToUnit) && subunitToUnit > 0 ? +subunitToUnit : 100;

    return (+this.fractional || 0) / divisor;
  }

  formattedPrice(separator: string = '') {
    return `${this.currencySymbol}${separator}${this.unit.toFixed(2)}`;
  }
}

